import { useEffect, useState } from "react";
import { Sparkles, Users } from "lucide-react";
import { api } from "@/lib/api";

const SIGN_GLYPHS = {
  Aries: "♈", Taurus: "♉", Gemini: "♊", Cancer: "♋",
  Leo: "♌", Virgo: "♍", Libra: "♎", Scorpio: "♏",
  Sagittarius: "♐", Capricorn: "♑", Aquarius: "♒", Pisces: "♓",
};

export default function SocialProof({ compact = false }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get("/social-proof")
      .then((r) => { if (!cancelled) setData(r.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!data) return null;
  if (data.total_readings === 0) return null;

  if (compact) {
    return (
      <div
        className="flex items-center gap-2 label-overline text-[color:var(--parchment-soft)]"
        data-testid="social-proof-compact"
      >
        <Users size={12} className="text-[color:var(--gold)]" />
        {data.this_week > 0 ? (
          <>{data.this_week} reading{data.this_week === 1 ? "" : "s"} in the last 7 days</>
        ) : (
          <>{data.total_readings} readings delivered so far</>
        )}
      </div>
    );
  }

  return (
    <div
      className="rounded-2xl border border-[color:var(--gold)]/20 p-6"
      style={{ background: "rgba(19, 27, 54, 0.5)" }}
      data-testid="social-proof-panel"
    >
      <div className="flex items-center justify-between mb-4">
        <div className="label-overline flex items-center gap-2">
          <Sparkles size={12} className="text-[color:var(--gold)]" /> Recently read
        </div>
        <div className="font-serif-italic text-[color:var(--text-secondary)] text-sm">
          {data.total_readings.toLocaleString()} chart{data.total_readings === 1 ? "" : "s"} · {data.this_week} this week
        </div>
      </div>
      {data.recent.length > 0 ? (
        <ul className="space-y-2.5">
          {data.recent.map((r, i) => (
            <li
              key={i}
              className="flex items-center gap-3 font-sans-body text-sm text-[color:var(--parchment-soft)]"
              data-testid={`social-proof-item-${i}`}
            >
              <span className="text-[color:var(--gold)] text-lg leading-none w-5 text-center">
                {SIGN_GLYPHS[r.sign] || "★"}
              </span>
              <span>
                A <span className="text-[color:var(--parchment)]">{r.sign}</span> reading
              </span>
              <span className="ml-auto font-serif-italic text-[color:var(--text-secondary)] text-xs">
                {r.when}
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <div className="font-serif-italic text-[color:var(--text-secondary)] text-sm">
          Be one of the first to receive a reading today.
        </div>
      )}
    </div>
  );
}
